import IColumnData from "../../../../common/interface/IColumnData";

export const ESTADO_PEDIDOS_COLUMN = (isAdmin: boolean): IColumnData[] => [
  {
    width: 100,
    label: "Status",
    dataKey: "estado",
  },
  {
    width: 80,
    label: "DATA DE CRIAÇÃO",
    dataKey: "fecha",
  },
  ...(isAdmin
    ? [
        {
          width: 80,
          label: "CLIENTE",
          dataKey: "clienteId",
        },
      ]
    : []),
  // {
  //     width: 40,
  //     label: 'PRESUPUESTO',
  //     dataKey: 'presuportalId',
  //     numeric: true,
  // },
  {
    width: 40,
    label: "PEDIDO",
    dataKey: "pedidoId",
    numeric: true,
  },
  {
    width: 20,
    label: "ITEM",
    dataKey: "item",
    numeric: true,
  },
  {
    width: 50,
    label: "ID PRODUTO",
    dataKey: "productoId",
    numeric: true,
  },
  {
    width: 120,
    label: "PRODUTO",
    dataKey: "descripcion",
    numeric: true,
  },
  {
    width: 40,
    label: "QUANTIDADE",
    dataKey: "cantidad",
    numeric: true,
  },
  // {
  //     width: 80,
  //     label: 'FECHA REMITO',
  //     dataKey: 'fechaRemito'
  // },
  // {
  //     width: 40,
  //     label: 'REMITO',
  //     dataKey: 'remitoId',
  //     numeric: true,
  // },
  {
    width: 40,
    label: "SERIE",
    dataKey: "serie",
    numeric: true,
  },
  {
    width: 40,
    label: "NF",
    dataKey: "facturaId",
    numeric: true,
  },
  ...(!isAdmin
    ? [
        {
          width: 80,
          label: "COMEÇAR RECLAMAÇÕES",
          dataKey: "puedeCargarReclamo",
          boolean: true,
        },
      ]
    : []),
  // {
  //   width: 40,
  //   label: "SEGUIMENTO",
  //   dataKey: "puedeHacerSeguimiento",
  //   boolean: true,
  // },
  {
    width: 40,
    label: "DATA DE ATUALIZAÇÃO",
    dataKey: "fechaActualizacion",
  },
];
